import { trackButtonClick } from "@/utils/analytics";
import { trackFilterInteraction, getSrpLocationLabel } from "@/utils/filterTrackingService";
import { useSelector } from "react-redux";

const Pagination = ({ pageNumber, setPageNumber }) => {
  const srpInitData = useSelector((state) => state.srp.srpInitData);
  const totalResultCount = srpInitData?.totalResultCount || 0;
  const recordsPerPage = srpInitData?.recordPerPage || 1;

  const totalPageTemp = totalResultCount / recordsPerPage;
  const totalPage =
    totalPageTemp <= Math.floor(totalPageTemp)
      ? Math.floor(totalPageTemp)
      : Math.floor(totalPageTemp) + 1;

  const handlePageClick = (newPage) => {
    if (newPage !== pageNumber) {
      setPageNumber(newPage);
      const direction = newPage > pageNumber ? "Next" : "Previous";
      trackButtonClick({
        eventName: "pagination_page_change",
        eventSource: "SRP Pagination",
        eventCategory: "NEW-SRP",
        eventLabel: `Pagination ${direction}: From Page ${pageNumber} to Page ${newPage} of ${totalPage} | Location: ${getSrpLocationLabel()}`,
      });
      // Track via filter interaction API
      trackFilterInteraction('FILTER_SELECTED');
    }
  };

  if (totalResultCount === 0) {
    return <></>; // No data to paginate
  }

  if (totalPage === 1) {
    return <div className="mb100" />; // Only one page, no pagination needed
  }

  return (
    <>
      <ul className="pagination-navigation">
        <li className="pagination-container">
          <div
            className={`pagination-link ${pageNumber >= 2 ? "" : "disabled"}`}
            onClick={() => {pageNumber >= 2 && handlePageClick(pageNumber - 1)}}
          >
            <span className="flaticon-left-arrow"></span>
          </div>
        </li>
        {pageNumber > 5 && <li className={`pagination-container`}>
          <div
            className="pagination-link"
            onClick={() => handlePageClick(1)}
          >1</div>
        </li>}
        {pageNumber > 5 && <li className="pagination-container">
          <div
            className="pagination-link disabled pagination-dots"
            onClick={() => {}}
          >
            ...
          </div>
        </li>}
        {(pageNumber <= 5 || pageNumber === totalPage) && pageNumber - 4 > 0 && <li className={`pagination-container`}>
          <div
            className="pagination-link"
            onClick={() => handlePageClick(pageNumber - 4)}
          >
            {pageNumber - 4}
          </div>
        </li>}
        {(pageNumber <= 5 || pageNumber === totalPage || pageNumber === totalPage - 1) && pageNumber - 3 > 0 && <li className={`pagination-container`}>
          <div
            className="pagination-link"
            onClick={() => handlePageClick(pageNumber - 3)}
          >
            {pageNumber - 3}
          </div>
        </li>}
        {pageNumber - 2 > 0 && <li className={`pagination-container`}>
          <div
            className="pagination-link"
            onClick={() => handlePageClick(pageNumber - 2)}
          >
            {pageNumber - 2}
          </div>
        </li>}
        {pageNumber - 1 > 0 && <li className={`pagination-container`}>
          <div
            className="pagination-link"
            onClick={() => handlePageClick(pageNumber - 1)}
          >
            {pageNumber - 1}
          </div>
        </li>}
        <li  className={`pagination-container`}>
          <div
            className="pagination-link active"
            onClick={() => handlePageClick(pageNumber)}
          >
            {pageNumber}
          </div>
        </li>
        {(pageNumber + 1 <= totalPage) && <li className={`pagination-container`}>
          <div
            className="pagination-link"
            onClick={() => handlePageClick(pageNumber + 1)}
          >
            {pageNumber + 1}
          </div>
        </li>}
        {(pageNumber + 2 <= totalPage) && <li className={`pagination-container`}>
          <div
            className="pagination-link"
            onClick={() => handlePageClick(pageNumber + 2)}
          >
            {pageNumber + 2}
          </div>
        </li>}
        {/* && (pageNumber > totalPage - 5) */}
        {(pageNumber + 3 <= totalPage) && ((pageNumber > totalPage - 5) || (pageNumber <= 2 && totalPage >= 4)) && <li className={`pagination-container`}>
          <div
            className="pagination-link"
            onClick={() => handlePageClick(pageNumber + 3)}
          >
            {pageNumber + 3}
          </div>
        </li>}
        {/* && (pageNumber > totalPage - 4) */}
        {(pageNumber + 4 <= totalPage) && ((pageNumber > totalPage - 4) || (pageNumber <= 1 && totalPage >= 4)) && <li className={`pagination-container`}>
          <div
            className="pagination-link"
            onClick={() => handlePageClick(pageNumber + 4)}
          >
            {pageNumber + 4}
          </div>
        </li>}
        {pageNumber + 4 < totalPage && <li className="pagination-container">
          <div
            className="pagination-link disabled pagination-dots"
            onClick={() => {}}
          >
            ...
          </div>
        </li>}
        {pageNumber + 4 <= totalPage && <li className="pagination-container">
          <div
            className="pagination-link"
            onClick={() => handlePageClick(totalPage)}
          >
            {totalPage}
          </div>
        </li>}
        <li className="pagination-container">
          <div
            className={`pagination-link pagination-link-last ${pageNumber < totalPage ? "" : "disabled"}`}
            onClick={() => {pageNumber < totalPage && handlePageClick(pageNumber + 1)}}
          >
            <span className="flaticon-right-arrow"></span>
          </div>
        </li>
      </ul>
      <div className="pagination-result-text mb20">{pageNumber * 22 - 21} - {totalResultCount < pageNumber * 22 ? totalResultCount : pageNumber * 22} of {totalResultCount} properties</div>
    </>
  );
};

export default Pagination;
